import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Quadro',
  path: '/pessoal/pesquadro',
  name: 'pesquadro',
  component: () => import('@/views/pessoal/pesquadro/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.QUADRONOVO_MENU_1400700599],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Quadro',
  path: '/pessoal/pesquadro/cadastro/:id?',
  parent: 'pesquadro',
  name: 'pesquadro_create',
  component: () => import('@/views/pessoal/pesquadro/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.QUADRONOVO_MENU_1400700599],
  },
  goesToMenu: true,
 },
]
